import { render, staticRenderFns } from "./DataProductsDrawer.vue?vue&type=template&id=a7daad20&scoped=true&lang=pug"
import script from "./DataProductsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProductsDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataProductsDrawer.vue?vue&type=style&index=0&id=a7daad20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7daad20",
  null
  
)

export default component.exports